export default "__VITE_ASSET__BYlM4tr5__"